const registerWizardStepKeys = {
  PERSONAL_DATA: 'personalData',
  USER_VALIDATION: 'userValidation',
  PASSWORD: 'password',
  PRIVACY_POLICY: 'privacyPolicy'
};

const registerDisplayModes = {
  HIDE: 'hide',
  SHOW: 'show',
  MANDATORY: 'mandatory'
}

const registerPatientDisplayModes = {
  OPTIONAL: 'optional',
  SELECTABLE: 'selectable',
  REQUIRED: 'required'
}

export {
  registerWizardStepKeys,
  registerDisplayModes,
  registerPatientDisplayModes
};
